module.exports = __webpack_public_path__ + "static/media/scenario-1.de21fbfe.png";